import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
} from "@chakra-ui/react";
import { useStripe } from "@stripe/react-stripe-js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { switchWorkspace } from "../../_actions/authActions";
import { CREATE_CHECKOUT_SESSION_ENDPOINT } from "../../_actions/endpoints";
import { getAuthToken } from "../../_utils/common";
import { ShowCenterSpinner } from "./statelessView";
import { showToast } from "../../_utils/showToast";

function TldrSelectWorkspaceModal({ onClose, isOpen, auth, switchWorkspace }) {
  const {
    payload: { orgs },
  } = auth;

  const [workspace, setWorkspace] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const stripe = useStripe();

  useEffect(() => {
    if (orgs && orgs.length === 1) {
      setIsLoading(true);
      handleContinue();
    } else {
      setWorkspace(orgs[0].id);
    }
  }, []);

  const handleOnSelect = (selectedOrg) => {
    setWorkspace(selectedOrg);
    setIsLoading(true);
    switchWorkspace(selectedOrg, getAuthToken()).then((res) =>
      setIsLoading(false)
    );
  };

  function handleContinue() {
    setIsLoading(true);

    axios
      .post(CREATE_CHECKOUT_SESSION_ENDPOINT, {
        plan_name: localStorage.getItem("planName"),
        promo_code: localStorage.getItem("promoCode"),
      })
      .then((res) => {
        localStorage.removeItem("planName");
        localStorage.removeItem("promoCode");
        stripe.redirectToCheckout({ sessionId: res.data.session_id });
        setIsLoading(false);
        onClose();
      })
      .catch((err) => {
        localStorage.removeItem("planName");
        localStorage.removeItem("promoCode");
        setIsLoading(false);
        onClose();
        showToast({
          description: err?.response?.data[0],
          title: "failed",
          status: "error",
        });
      });
  }

  return (
    <>
      {orgs && orgs.length === 1 ? (
        <ShowCenterSpinner loaded={!isLoading} />
      ) : (
        <Modal
          onClose={onClose}
          isOpen={isOpen}
          closeOnOverlayClick={false}
          isCentered
        >
          <ModalOverlay background="brand.overlayDark" />
          <ModalContent>
            <ModalHeader>Choose Workspace</ModalHeader>
            <Divider my="0" />
            <ModalBody>
              <ShowCenterSpinner loaded={!isLoading} />
              <RadioGroup
                onChange={(e) => handleOnSelect(Number(e))}
                value={workspace}
              >
                <Stack direction="column">
                  {orgs &&
                    orgs.map((org) => (
                      <Radio key={org.id} value={org.id} mb="1" mt="1">
                        {org.name}
                      </Radio>
                    ))}
                </Stack>
              </RadioGroup>
            </ModalBody>
            <Divider my={0} />
            <ModalFooter>
              <Button
                variant="solid"
                disabled={isLoading}
                isLoading={isLoading}
                onClick={() => handleContinue()}
              >
                Continue
              </Button>
            </ModalFooter>
            <ModalCloseButton />
          </ModalContent>
        </Modal>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  switchWorkspace: (workspaceId, token) =>
    dispatch(switchWorkspace(workspaceId, token)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TldrSelectWorkspaceModal);
